export default "<div class=\"\">\n  <router-outlet></router-outlet>\n  <div style=\"height: 70px;\"></div>\n</div>"